export default __webpack_public_path__ + "static/media/f2566e2bc1750cf47b4830483290281a.svg";